import { ChangeDetectionStrategy, Component, input } from '@angular/core';

// Bordered box with a grey title bar; rows or free content go in the body.
@Component({
  selector: 'lib-card',
  templateUrl: './card.html',
  styleUrl: './card.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CardComponent {
  cardTitle = input<string>('');
}
